import { useQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { getActivityIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useActivityQuery = (id: number | null) => {
	return useQuery({
		queryKey: ActivityKeys.detail(id),
		queryFn: processResponse(() => getActivityIdV2(id!)),
		enabled: id !== null,
	});
};
